import React from 'react';
import { HStack, Image, Spacer, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { OperatingInstruction } from './OperatingInstruction';

export const Header = () => {
    const { t } = useTranslation();
    return (
        <HStack>
            <Image src="https://outbankapp.com/wp-content/uploads/Outbank-Logo.svg" />
            <Spacer />
            <OperatingInstruction />
        </HStack>
    );
};
